import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NetLossesDTO } from './net-losses.model';

@Injectable({
  providedIn: 'root',
})
export class NetLossesService {
  constructor(private http: HttpClient) {}

  public get(playerId: number): Observable<NetLossesDTO> {
    return this.http.get<NetLossesDTO>(`/player-activity/api/players/${playerId}/net-losses`);
  }
}
